module.exports = __webpack_public_path__ + "img/pdf-download.c29bf3df.png";